const Contact = () => {
    const user = "baptistchurchalkapur";
    const domain = "gmail.com";
    const email = `${user}@${domain}`;
    return (

        <div className='main-container'>
            <div className="main-wrapper">
                <section className="review-area pb-100 pt-40" id="mission">
                    <div className="container">
                        <div className="row justify-content-start align-items-center">
                            <div className="col-lg-6 video-left">
                                <br />
                                <header className="pt-120">
                                    <h1 className="page-heading">Contact</h1>
                                </header>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="video-sec-area pb-100 pt-40" id="about">
                    <div className="container">
                        <div className="row justify-content-start align-items-center">
                            <div className="col-lg-6 video-left">
                                <div className="single-footer-widget">
                                    <br />
                                    <div>
                                        <p className="contact-bold">
                                            Phone:
                                        </p>
                                        <a href='tel:+919949694869'>
                                            +91 9949694-869
                                        </a>
                                        <br />
                                        <a href={'tel:+918074617330'}>
                                            +91 8074617-330
                                        </a>
                                        <br />
                                        <br />
                                        <p className="contact-bold">
                                            Email:
                                        </p>
                                        <a href={`mailto: ${email}`}>
                                            {email}
                                        </a>
                                        <br />
                                        <br />
                                        <p className="contact-bold">
                                            Follow Us:
                                        </p>
                                        <div className="contact-social d-flex align-items-center">
                                            <a href="http://instagram.com/baptistchurchalkapoor" title="Instagram"><i className="fa-brands fa-instagram"></i></a>
                                            
                                            <a href="https://www.youtube.com/@AlkapoorBaptistChurch" title="YouTube"><i className="fa-brands fa-youtube"></i></a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </div>

    );
};

export default Contact;